<div class="container-chart">
  <h3>HISTORIAL DE ALARMAS (48 HORAS)</h3>
  <hr />
  <div id="chart"></div>
</div>